module.exports = __webpack_public_path__ + "static/img/laboratory4.f09d7c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/laboratory4.jpg
// module id = eTLM
// module chunks = 1